module.exports = __webpack_public_path__ + "static/media/imagem33.100c33e3.jpeg";